import { c as _c } from "react/compiler-runtime";
import type { AgentRunOutput } from '@onefootprint/request-types/dashboard';
import { Drawer } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import AgentExecutionSummary from '@/components/entities/components/details/components/content/components/agent-execution-summary';
type AgentExecutionEventDrawerProps = {
  open: boolean;
  onClose: () => void;
  output?: AgentRunOutput;
};
const AgentExecutionCompletedEventDrawer = t0 => {
  const $ = _c(20);
  const {
    open,
    onClose,
    output
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.agentExecutionEvent.drawer"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  bb0: switch (output?.agentKind) {
    case "watchlist_review":
      {
        let t3;
        if ($[1] !== t) {
          t3 = t(_temp);
          $[1] = t;
          $[2] = t3;
        } else {
          t3 = $[2];
        }
        t2 = t3;
        break bb0;
      }
    case "ai_decision":
      {
        let t3;
        if ($[3] !== t) {
          t3 = t(_temp2);
          $[3] = t;
          $[4] = t3;
        } else {
          t3 = $[4];
        }
        t2 = t3;
        break bb0;
      }
    case "document_extraction":
      {
        let t3;
        if ($[5] !== t) {
          t3 = t(_temp3);
          $[5] = t;
          $[6] = t3;
        } else {
          t3 = $[6];
        }
        t2 = t3;
        break bb0;
      }
    case "research":
      {
        let t3;
        if ($[7] !== t) {
          t3 = t(_temp4);
          $[7] = t;
          $[8] = t3;
        } else {
          t3 = $[8];
        }
        t2 = t3;
        break bb0;
      }
    default:
      {
        let t3;
        if ($[9] !== t) {
          t3 = t(_temp5);
          $[9] = t;
          $[10] = t3;
        } else {
          t3 = $[10];
        }
        t2 = t3;
      }
  }
  const title = t2;
  let t3;
  if ($[11] !== output) {
    t3 = output && <AgentExecutionSummary output={output} />;
    $[11] = output;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t3) {
    t4 = <div className="flex flex-col gap-3">{t3}</div>;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== onClose || $[16] !== open || $[17] !== t4 || $[18] !== title) {
    t5 = <Drawer open={open} title={title} onClose={onClose} size="large">{t4}</Drawer>;
    $[15] = onClose;
    $[16] = open;
    $[17] = t4;
    $[18] = title;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};
export default AgentExecutionCompletedEventDrawer;
function _temp($_3) {
  return $_3.title.watchlistReview;
}
function _temp2($_2) {
  return $_2.title.aiDecision;
}
function _temp3($_1) {
  return $_1.title.documentExtraction;
}
function _temp4($_0) {
  return $_0.title.research;
}
function _temp5($) {
  return $.title.defaultAgentKind;
}